import { useMutation } from "@tanstack/react-query";
import { AXIOS_RESERVATION } from "../utils/axios-interceptors";
import { IUseUpdateOfferMutationResponse } from "../utils/types";
import { queryClient } from "../App";

const useUpdateOurStoryStatus = (): IUseUpdateOfferMutationResponse =>
  useMutation({
    mutationFn: async (data: any) => {
      const response = await AXIOS_RESERVATION.post(
        `/edit-our-story-status`,
        data
      );
      return response.data;
    },
    onSuccess: () => {
      queryClient.refetchQueries({ queryKey: ["our-story"] });
    },
  });

export default useUpdateOurStoryStatus;
